const NODE_ENV = document.querySelector('meta[name="env"]')?.getAttribute("content") || "staging"
const CDN_URL = document.querySelector('meta[name="cdn_url"]')?.getAttribute("content") || "http://localhost:3000"
const IS_LOCAL = process.env.REACT_APP_IS_LOCAL as string

const LOCAL = "local"
const DEVELOPMENT = "development"
const STAGING = "staging"
const PRODUCTION = "production"

export {NODE_ENV, IS_LOCAL, DEVELOPMENT, LOCAL, STAGING, PRODUCTION, CDN_URL}
